import React, { useEffect } from 'react';
import './Settings.css';
import { useTranslation } from 'react-i18next';

function Settings() {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.setAttribute('lang', i18n.language);
  }, [i18n.language]);

  return (
    <div className="settings-container">
      <div className="settings-section">
        <h3 className="settings-section-title">{t("settings.notifications")}</h3>
        <div className="setting-item">
          <div className="setting-label">{t("settings.emailNotifications")}</div>
          <label className="toggle">
            <input type="checkbox" defaultChecked />
            <span></span>
          </label>
        </div>
        <div className="setting-item">
          <div className="setting-label">{t("settings.pushNotifications")}</div>
          <label className="toggle">
            <input type="checkbox" defaultChecked />
            <span></span>
          </label>
        </div>
      </div>

      <div className="settings-section">
        <h3 className="settings-section-title">{t("settings.display")}</h3>
        <div className="setting-item">
          <div className="setting-label">{t("settings.darkMode")}</div>
          <label className="toggle">
            <input type="checkbox" />
            <span></span>
          </label>
        </div>
        <div className="setting-item">
          <div className="setting-label">{t("settings.compactView")}</div>
          <label className="toggle">
            <input type="checkbox" />
            <span></span>
          </label>
        </div>
      </div>

      <div className="settings-section">
        <h3 className="settings-section-title">{t("settings.privacy")}</h3>
        <div className="setting-item">
          <div className="setting-label">{t("settings.showProfileToOthers")}</div>
          <label className="toggle">
            <input type="checkbox" defaultChecked />
            <span></span>
          </label>
        </div>
        <div className="setting-item">
          <div className="setting-label">{t("settings.shareActivityStatus")}</div>
          <label className="toggle">
            <input type="checkbox" defaultChecked />
            <span></span>
          </label>
        </div>
      </div>
    </div>
  );
}

export default Settings; 